import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App/App.jsx';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import WidgetPage from './pages/WidgetPage/WidgetPage';
import LessonPage from './pages/LessonPage/LessonPage';
import './styles.less';
 
const router = createBrowserRouter( 
    [
        {
            path: '/',
            element: <App/>,
            errorElement: <NotFoundPage/>,
            children: [
                {
                    path: '/course/:courseId?',
                    element: <WidgetPage/>,
                    title: 'L•EARN',
                },
                {
                    path: '/lesson',
                    title: 'L•EARN',
                    element: <LessonPage/>
                },
                {
                    path: '/oidc_signin?',
                    title: 'L•EARN',
                    element: <LessonPage/>
                },
                {
                    path: '/oidc_renew?',
                    title: 'L•EARN',
                    element: <LessonPage/>
                } 
            ]
        }
    ]
);
  
ReactDOM.createRoot( document.getElementById( 'app-root' ) ).render(
    <RouterProvider router={ router } />
);
